import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './locales/es.json';
import en from './locales/en.json';
import pl from './locales/pl.json';
import it from './locales/it.json';

const resources = {
  es: { translation: es },
  en: { translation: en },
  pl: { translation: pl },
  it: { translation: it },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'es',
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
});

export default i18n;
